export const UserStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'Deactivate'
}